import { Input, InputRef, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ForwardedRef } from 'react';

import { EntryText } from 'stores/models';

import { EntryConnectorProps } from '../types';

type EntryTextFieldProps = EntryConnectorProps & {
  model: EntryText;
  error?: boolean;
  disabled?: boolean;
  ComponentInput?: React.ComponentType<EntryConnectorProps>;
  loading?: boolean;
  onBlur?: () => void;
};

/** Компонент-обёртка для связи модели текстового ввода с инпутом из uikit*/
const EntryTextField: React.FC<EntryTextFieldProps> = React.forwardRef(
  (
    { model, ComponentInput = Input, disabled, error, loading, onBlur, ...props },
    ref: ForwardedRef<InputRef>
  ) => {
    const handlerChange = React.useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        model.setValue(e.currentTarget.value);
      },
      [model]
    );

    const handleBlur = React.useCallback(() => {
      model.touch();
      onBlur?.();
    }, [model, onBlur]);

    return (
      <ComponentInput
        {...props}
        prefix={loading ? <Spin size="small" /> : null}
        ref={ref}
        value={model.value}
        onChange={handlerChange}
        onBlur={handleBlur}
        disabled={model.disable || disabled}
        status={model.errorIfTouched.value || error ? 'error' : ''}
      />
    );
  }
);

export default observer(EntryTextField);
